import React from "react";
import { Link } from "react-router-dom";
import { MEDIA } from "../lib/media";
import { Reveal } from "../components/Reveal";

const BLOCKS = [
  { k: "Our Beginning", t: "A quiet idea, rooted in nature", c: "IAH began with a simple belief: that beauty, at its best, is honest. Inspired by the untouched landscapes of Meghalaya, we set out to create skincare that feels considered, gentle and true.", img: MEDIA.mist },
  { k: "The Meghalaya Inspiration", t: "Nature. Purity. Essence.", c: "Meghalaya's living root bridges, sacred forests and endless mist remind us that the most enduring things are grown patiently, with care. This philosophy guides how we formulate.", img: MEDIA.rootbridge },
  { k: "Our Philosophy", t: "Science, guided by nature", c: "We formulate with well-studied actives and a deep respect for the skin's natural balance. No noise, no excess — only what your skin needs.", img: MEDIA.fern },
  { k: "Our Promise", t: "Thoughtful, always", c: "Clean where it counts. Cruelty free. Made with intention. We create products we are proud to use ourselves, and rituals we hope you'll love.", img: MEDIA.ritual },
];

export default function OurStory() {
  return (
    <div>
      <section className="relative h-[70vh] min-h-[460px] flex items-end overflow-hidden">
        <img src={MEDIA.storyFull} alt="Meghalaya" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/45" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 pb-16 text-ivory">
          <Reveal><span className="eyebrow text-ivory/80">Our Story</span><h1 className="serif text-5xl lg:text-7xl mt-3 leading-[1.05]">Inspired by Nature.<br />Rooted in Meghalaya.</h1></Reveal>
        </div>
      </section>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-24 space-y-28">
        {BLOCKS.map((b, i) => (
          <div key={b.k} className={`grid lg:grid-cols-2 gap-14 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
            <Reveal className="lg:[direction:ltr]"><span className="eyebrow text-moss">{b.k}</span><h2 className="serif text-4xl lg:text-5xl mt-3 mb-5">{b.t}</h2><p className="text-forest/70 leading-relaxed">{b.c}</p></Reveal>
            <Reveal className="lg:[direction:ltr]"><div className="overflow-hidden aspect-[4/3]"><img src={b.img} alt="" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" /></div></Reveal>
          </div>
        ))}
        <div className="text-center"><Link to="/shop" className="btn-primary">Explore the Collection</Link></div>
      </div>
    </div>
  );
}
